module.exports = __webpack_public_path__ + "img/linkedin.dc0af79d.jpg";